import React from 'react'
import {Button, Label} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import SearchSelectInput from "./SearchSelectInput"
import {pageHelpers} from '../pages'

class ProvisionTeamForm extends React.Component {

    constructor(props) {
        super(props)
        const {searchForControllers, onSubmit, controllers, email} = props

        this.state = {
            teamName: '',
            adminEmail: email || '',
            controllers: controllers || []
        }

        this.onSubmit = onSubmit
        this.searchForControllers = searchForControllers
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
    }

    componentDidMount() {
        pageHelpers.setupSingleRunAnimationEvents()
    }

    componentWillUnmount() {
        pageHelpers.tearDownSingleRunAnimationEvents()
    }

    handleValidSubmit(event, values) {
        event.preventDefault()
        let {teamName, adminEmail, controllers} = values
        this.onSubmit(teamName, adminEmail, controllers)
        this.setState({teamName: '', adminEmail: '', controllers: []})
    }

    componentWillReceiveProps(nextProps) {
        const {searchForControllers, onSubmit, controllers, email} = nextProps

        const oldEmail = this.state.adminEmail
        const oldControllers = this.state.controllers

        this.setState({
            adminEmail: email || oldEmail,
            controllers: controllers || oldControllers
        })

        this.onSubmit = onSubmit
        this.searchForControllers = searchForControllers
    }

    render() {
        let {controllers} = this.state

        return <AvForm onValidSubmit={this.handleValidSubmit}
                        onInvalidSubmit={pageHelpers.handleInvalidFormSubmit}
                        model={this.state} className="text-left col-12 col-sm-10 col-md-8 col-lg-6 offset-0 offset-sm-1 offset-md-2 offset-lg-3 no-gutters">
            <AvGroup>
                <Label for="teamName">Team Name</Label>
                <AvInput placeholder="Team Name"
                          type="text"
                          name="teamName"
                          minLength={3}
                          autoComplete="organization"
                          required={true}/>
                <AvFeedback>Please enter a valid team name. (at least 3 characters)</AvFeedback>
            </AvGroup>
            <AvGroup>
                <Label for="adminEmail">Admin Email</Label>
                <AvInput type="email"
                          name="adminEmail"
                          placeholder="admin@team.com"
                          autoComplete="email"
                          required={true}/>
                <AvFeedback>Please enter a valid email address.</AvFeedback>
            </AvGroup>
            <AvGroup>
                <Label for="controllers">Controllers</Label>
                <SearchSelectInput
                    search={(query) => this.searchForControllers(query)}
                    onChange={(controllers) => this.setState({controllers})}
                    initialValue={controllers}
                    multipleSelection={true}
                    placeholder="Controller Phone Number"/>
                <AvInput type="text"
                         name="controllers"
                         hidden={true}/>
            </AvGroup>
            <AvGroup className="col-12 text-center">
                <Button>Provision</Button>
            </AvGroup>
        </AvForm>
    }
}

export default ProvisionTeamForm



// WEBPACK FOOTER //
// ./src/components/ui/ProvisionTeamForm.js